// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 전체 레이아웃 - 브라우저 전체 높이 사용, 외부 스크롤 없음 */
.app-layout {
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #f5f6fa;
  overflow: hidden;
}

/* 상단 헤더 */
.app-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  height: 56px;
  background-color: #1a1a2e;
  color: white;
  flex-shrink: 0;
}

.header-title {
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: -0.3px;
}

.header-title-btn {
  cursor: pointer;
  transition: opacity 0.15s;
}
.header-title-btn:hover  { opacity: 0.75; }
.header-title-btn:active { opacity: 0.55; }

.header-dot {
  display: inline-block;
  font-size: 0.55rem;
  vertical-align: middle;
  margin: 0 1px;
  position: relative;
  top: -1px;
  color: #a0c4ff;
}

.header-user {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-name {
  font-size: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.admin-badge {
  background-color: #e74c3c;
  color: white;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 10px;
  font-weight: 600;
}

.logout-button {
  padding: 6px 14px;
  background-color: transparent;
  color: #ccc;
  border: 1px solid #555;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
}

.logout-button:hover {
  background-color: #fff;
  color: #1a1a2e;
  border-color: #fff;
}

/* 탭 메뉴 바 - 왼쪽부터 상시 노출 버튼, 구분선, 그룹 드롭다운을 한 줄로 배치 */
.tab-nav {
  display: flex;
  align-items: center;
  background-color: #16213e;
  padding: 0 16px;
  flex-shrink: 0;
  position: relative;
  /* 창 폭이 좁아 내용이 다 안 들어가면 줄바꿈 대신 가로 스크롤 (드롭다운 레이아웃 깨짐 방지) */
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: visible;
  scrollbar-width: thin;
}

.tab-nav::-webkit-scrollbar {
  height: 4px;
}
.tab-nav::-webkit-scrollbar-thumb {
  background-color: #3a4a6c;
  border-radius: 2px;
}

.primary-tab-button {
  flex-shrink: 0;
  padding: 10px 16px;
  background: transparent;
  color: #cdd9e8;
  border: none;
  border-bottom: 2px solid transparent;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.primary-tab-button:hover {
  color: white;
  background-color: rgba(255, 255, 255, 0.06);
}

.primary-tab-button.active {
  color: #4a9eff;
  border-bottom-color: #4a9eff;
}

.nav-divider {
  flex-shrink: 0;
  width: 1px;
  height: 20px;
  margin: 0 8px;
  background-color: #2a3a5c;
}

.dropdown-group {
  flex-shrink: 0;
  position: relative;
  border-right: 1px solid #2a3a5c;
}

.dropdown-group:last-child {
  border-right: none;
}

.dropdown-toggle {
  display: flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: none;
  color: #8899aa;
  padding: 8px 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.dropdown-toggle:hover,
.dropdown-group.open .dropdown-toggle {
  color: white;
  background-color: rgba(255, 255, 255, 0.05);
}

.dropdown-caret {
  font-size: 8px;
  opacity: 0.7;
  transition: transform 0.2s;
}

.dropdown-group.open .dropdown-caret {
  transform: rotate(180deg);
}

/* Portal로 body 바로 아래에 렌더링됨 - .tab-nav의 overflow-x: auto에 딸려
   overflow-y까지 auto로 계산되어(스펙상 x/y 중 하나라도 visible이 아니면
   나머지도 auto로 취급) 세로로 잘리는 문제를 피하기 위해 fixed 좌표로 배치.
   top/left는 JS에서 토글 버튼의 getBoundingClientRect() 기준으로 계산해 inline-style로 넣어줌. */
.dropdown-content {
  display: flex;
  flex-direction: column;
  position: fixed;
  min-width: 168px;
  background-color: #1a2440;
  border: 1px solid #2a3a5c;
  border-radius: 6px;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);
  padding: 6px 0;
  z-index: 1000;
}

.dropdown-item {
  padding: 8px 16px;
  background: transparent;
  color: #aabbcc;
  border: none;
  text-align: left;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
}

.dropdown-item:hover {
  color: white;
  background-color: rgba(255, 255, 255, 0.08);
}

.dropdown-item.active {
  color: #4a9eff;
  font-weight: 600;
}

/* 탭 컨텐츠 영역 - 내부 PageLayout이 스크롤 관리 */
.tab-content {
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/components/TabLayout.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA,2BAA2B,aAAa,EAAE;AAC1C,2BAA2B,aAAa,EAAE;;AAE1C;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yDAAyD;EACzD,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;8EAG8E;AAC9E;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;EAC3C,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,qCAAqC;AACrC;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB","sourcesContent":["/* 전체 레이아웃 - 브라우저 전체 높이 사용, 외부 스크롤 없음 */\n.app-layout {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background-color: #f5f6fa;\n  overflow: hidden;\n}\n\n/* 상단 헤더 */\n.app-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 24px;\n  height: 56px;\n  background-color: #1a1a2e;\n  color: white;\n  flex-shrink: 0;\n}\n\n.header-title {\n  font-size: 1.1rem;\n  font-weight: 700;\n  letter-spacing: -0.3px;\n}\n\n.header-title-btn {\n  cursor: pointer;\n  transition: opacity 0.15s;\n}\n.header-title-btn:hover  { opacity: 0.75; }\n.header-title-btn:active { opacity: 0.55; }\n\n.header-dot {\n  display: inline-block;\n  font-size: 0.55rem;\n  vertical-align: middle;\n  margin: 0 1px;\n  position: relative;\n  top: -1px;\n  color: #a0c4ff;\n}\n\n.header-user {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.user-name {\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.admin-badge {\n  background-color: #e74c3c;\n  color: white;\n  font-size: 11px;\n  padding: 2px 6px;\n  border-radius: 10px;\n  font-weight: 600;\n}\n\n.logout-button {\n  padding: 6px 14px;\n  background-color: transparent;\n  color: #ccc;\n  border: 1px solid #555;\n  border-radius: 4px;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.logout-button:hover {\n  background-color: #fff;\n  color: #1a1a2e;\n  border-color: #fff;\n}\n\n/* 탭 메뉴 바 - 왼쪽부터 상시 노출 버튼, 구분선, 그룹 드롭다운을 한 줄로 배치 */\n.tab-nav {\n  display: flex;\n  align-items: center;\n  background-color: #16213e;\n  padding: 0 16px;\n  flex-shrink: 0;\n  position: relative;\n  /* 창 폭이 좁아 내용이 다 안 들어가면 줄바꿈 대신 가로 스크롤 (드롭다운 레이아웃 깨짐 방지) */\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  overflow-y: visible;\n  scrollbar-width: thin;\n}\n\n.tab-nav::-webkit-scrollbar {\n  height: 4px;\n}\n.tab-nav::-webkit-scrollbar-thumb {\n  background-color: #3a4a6c;\n  border-radius: 2px;\n}\n\n.primary-tab-button {\n  flex-shrink: 0;\n  padding: 10px 16px;\n  background: transparent;\n  color: #cdd9e8;\n  border: none;\n  border-bottom: 2px solid transparent;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.primary-tab-button:hover {\n  color: white;\n  background-color: rgba(255, 255, 255, 0.06);\n}\n\n.primary-tab-button.active {\n  color: #4a9eff;\n  border-bottom-color: #4a9eff;\n}\n\n.nav-divider {\n  flex-shrink: 0;\n  width: 1px;\n  height: 20px;\n  margin: 0 8px;\n  background-color: #2a3a5c;\n}\n\n.dropdown-group {\n  flex-shrink: 0;\n  position: relative;\n  border-right: 1px solid #2a3a5c;\n}\n\n.dropdown-group:last-child {\n  border-right: none;\n}\n\n.dropdown-toggle {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: transparent;\n  border: none;\n  color: #8899aa;\n  padding: 8px 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n\n.dropdown-toggle:hover,\n.dropdown-group.open .dropdown-toggle {\n  color: white;\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.dropdown-caret {\n  font-size: 8px;\n  opacity: 0.7;\n  transition: transform 0.2s;\n}\n\n.dropdown-group.open .dropdown-caret {\n  transform: rotate(180deg);\n}\n\n/* Portal로 body 바로 아래에 렌더링됨 - .tab-nav의 overflow-x: auto에 딸려\n   overflow-y까지 auto로 계산되어(스펙상 x/y 중 하나라도 visible이 아니면\n   나머지도 auto로 취급) 세로로 잘리는 문제를 피하기 위해 fixed 좌표로 배치.\n   top/left는 JS에서 토글 버튼의 getBoundingClientRect() 기준으로 계산해 inline-style로 넣어줌. */\n.dropdown-content {\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  min-width: 168px;\n  background-color: #1a2440;\n  border: 1px solid #2a3a5c;\n  border-radius: 6px;\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.35);\n  padding: 6px 0;\n  z-index: 1000;\n}\n\n.dropdown-item {\n  padding: 8px 16px;\n  background: transparent;\n  color: #aabbcc;\n  border: none;\n  text-align: left;\n  font-size: 12px;\n  cursor: pointer;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n\n.dropdown-item:hover {\n  color: white;\n  background-color: rgba(255, 255, 255, 0.08);\n}\n\n.dropdown-item.active {\n  color: #4a9eff;\n  font-weight: 600;\n}\n\n/* 탭 컨텐츠 영역 - 내부 PageLayout이 스크롤 관리 */\n.tab-content {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
